import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import contact_info_bg from "../assets/img/contact_info_bg.jpg";
import ContactPageImage from "../assets/img/ContactPageImage.jpg";
import { useFormik } from "formik";
import axios from "axios";
import { motion } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReCAPTCHA from "react-google-recaptcha";

function Contact() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Contact";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // mobileNumber, email, subject, fullName
  const [fullNameError, setFullNameError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subjectError, setSubjectError] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaValueError, setCaptchaValueError] = useState("");

  // Handle reCAPTCHA change
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    setCaptchaValueError("");
  };

  const formik = useFormik({
    initialValues: {
      fullName: "",
      mobileNumber: "",
      email: "",
      subject: "",
      description: "",
    },
    onSubmit: async (values, { resetForm }) => {
      let errorMessage = 0;
      const fullNameValidation = /^[a-zA-Z\s]+(?: [a-zA-Z\s]+)*$/;
      const mobileNumberValidation = /^\d{10}$/;
      const emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (values.fullName === "") {
        setFullNameError("Full Name is Required");
        errorMessage++;
      } else if (!values.fullName.match(fullNameValidation)) {
        setFullNameError("Full Name Must Be Valid");
        errorMessage++;
      }

      if (values.mobileNumber === "") {
        setMobileNumberError("Phone Number is Required");
        errorMessage++;
      } else if (!values.mobileNumber.match(mobileNumberValidation)) {
        setMobileNumberError("Phone Number Must Be Valid");
        errorMessage++;
      } else if (values.mobileNumber == "0000000000") {
        setMobileNumberError("Phone Number Must Be Valid");
        errorMessage++;
      }

      if (values.email === "") {
        setEmailError("Email is Required");
        errorMessage++;
      } else if (!values.email.match(emailValidation)) {
        setEmailError("Email Must Be Valid");
        errorMessage++;
      }

      if (values.subject === "") {
        setSubjectError("Subject is Required");
        errorMessage++;
      }

      const param = {
        fullName: values.fullName,
        mobileNumber: values.mobileNumber,
        email: values.email,
        subject: values.subject,
        description: values.description,
      };

      if (errorMessage == 0) {
        if (captchaValue !== "") {
          const response = await axios.post(
            "https://serverapi.xpertlab.com/zeppoli/contactusform",
            param,
            {
              headers: {
                apitoken: "b361d6655jrsd4dd02efaf412ed585sd",
                "Content-Type": "application/json",
              },
            }
          );
          if (response.status === 200) {
            if (response.data.status === 200) {
              toast.success("Data Submitted Successfully");
              resetForm();
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            } else {
              toast.error("Please Fill the Form");
            }
          } else {
            toast.error("Something Went Wrong");
          }
        } else {
          setCaptchaValueError("Please Check Captcha");
        }
      }
    },
  });

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    // Set a timeout to change the visibility after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <ToastContainer />
      <Navbar />
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper" data-bg-src={ContactPageImage}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Contact Us</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Contact Us</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>
      {isVisible && (
        <div className="space">
          <div className="container">
            <div className="row gy-4">
              <div className="col-lg-4" data-aos="fade-up">
                <div
                  className="contact-info"
                  data-bg-src={contact_info_bg}
                  style={{ height: "300px" }}
                >
                  <div className="contact-info_icon">
                    <i className="fal fa-location-dot"></i>
                  </div>
                  <h4 className="contact-info_title box-title">Our Address</h4>
                  <span className="contact-info_text">
                    {" "}
                    (589/3/P3/P3) <br />
                    Near Bhola Patiya Old Upleta Road, <br />
                    Dhoraji, Dist. Rajkot Gujarat - 360410
                  </span>
                </div>
              </div>
              <div className="col-lg-4" data-aos="flip-left">
                <div
                  className="contact-info"
                  data-bg-src={contact_info_bg}
                  style={{ height: "300px" }}
                >
                  <div className="contact-info_icon">
                    <i className="fal fa-envelope"></i>
                  </div>
                  <h4 className="contact-info_title box-title">
                    Email Address
                  </h4>
                  <span className="contact-info_text">
                    <a
                      href="mailto:zeppolifoods123@gmail.com"
                      name="Zeppoli email"
                      aria-label="Zeppoli email"
                    >
                      zeppolifoods123@gmail.com
                    </a>
                  </span>
                </div>
              </div>
              <div className="col-lg-4" data-aos="fade-down">
                <div
                  className="contact-info"
                  data-bg-src={contact_info_bg}
                  style={{ height: "300px" }}
                >
                  <div className="contact-info_icon">
                    <i className="fal fa-phone"></i>
                  </div>
                  <h4 className="contact-info_title box-title">Phone Number</h4>
                  <span className="contact-info_text">
                    <a
                      href="tel:+919978232123"
                      name="Zeppoli contact number"
                      aria-label="Zeppoli contact number"
                    >
                      (+91) 99782 32123
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={variants5}
        >
          <div className="" id="mapSec">
            <div className="contact-map2">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d237433.03849046442!2d70.45264078695838!3d21.590168579016478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1szeppoli%20bakers!5e0!3m2!1sen!2sin!4v1702958777121!5m2!1sen!2sin"
                title="zeppoli Map"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </motion.div>
      )}
      {isVisible && (
        <section className="space-bottom contact-form-sec">
          <div className="container">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <div className="reservation-area">
                <h4 className="sec-title text-center mb-30">Contact Us</h4>
                <div className="booking-form3 ajax-contact">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                      <div className="form-group col-lg-3 col-md-6">
                        <input
                          type="text"
                          className="form-control rounded-2"
                          placeholder="Your Name"
                          {...formik.getFieldProps("fullName")}
                          onChange={(e) => {
                            formik.setFieldValue("fullName", e.target.value);
                            setFullNameError("");
                          }}
                        />
                        <i className="far fa-user"></i>
                        <span className="text-danger">{fullNameError}</span>
                      </div>
                      <div className="form-group col-lg-3 col-md-6">
                        <input
                          type="tel"
                          className="form-control rounded-2"
                          placeholder="Phone Number"
                          {...formik.getFieldProps("mobileNumber")}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "mobileNumber",
                              e.target.value
                            );
                            setMobileNumberError("");
                          }}
                        />
                        <i className="far fa-phone"></i>
                        <span className="text-danger">{mobileNumberError}</span>
                      </div>
                      <div className="form-group col-lg-3 col-md-6">
                        <input
                          type="text"
                          className="form-control rounded-2"
                          placeholder="Email"
                          {...formik.getFieldProps("email")}
                          onChange={(e) => {
                            formik.setFieldValue("email", e.target.value);
                            setEmailError("");
                          }}
                        />
                        <i className="far fa-envelope"></i>
                        <span className="text-danger">{emailError}</span>
                      </div>
                      <div className="form-group col-lg-3 col-md-6">
                        <input
                          type="text"
                          className="form-control rounded-2"
                          placeholder="Subject"
                          {...formik.getFieldProps("subject")}
                          onChange={(e) => {
                            formik.setFieldValue("subject", e.target.value);
                            setSubjectError("");
                          }}
                        />
                        <i className="far fa-tag"></i>
                        <span className="text-danger">{subjectError}</span>
                      </div>
                      <div className="form-group col-12">
                        <textarea
                          cols="30"
                          rows="3"
                          className="form-control rounded-2"
                          placeholder="Write Message"
                          {...formik.getFieldProps("description")}
                        ></textarea>
                        <i className="far fa-comment"></i>
                      </div>
                      <div className="form-group col-12">
                        <div className="fw-bold text-primary mt-4 mx-2">
                          <ReCAPTCHA
                            sitekey="6Lfm3PcqAAAAACvfCZKWxwHJssSxiAODpGFvIE0A"
                            onChange={handleCaptchaChange}
                          />
                          <span className="text-danger">
                            {captchaValueError}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="form-btn text-center">
                      <button
                        type="submit"
                        className="th-btn rounded-2"
                        name="formSubmit"
                        aria-label="formSubmit"
                      >
                        Send Message
                        <i className="fa-solid fa-arrow-right ms-2"></i>
                      </button>
                    </div>
                  </form>
                  <p className="form-messages mb-0 mt-3"></p>
                </div>
              </div>
            </motion.div>
          </div>
        </section>
      )}

      <Footer />
    </>
  );
}

export default Contact;
